
export enum VideoReviewSubStatus {
    None,
    NoActionRequired,
    ActionRequired
}
